import { useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import styles from "../Styles/loginPage.module.css";

import {
  Button,
  Paper,
  Typography,
  Grid,
} from "@mui/material";
import { postData } from "../Services/postData";
import { localUrlEnum, endpoints } from "../Utils/UrlEnum";
import { useNavigate, useParams } from "react-router-dom";
import { Vocabulary } from "../Utils/Vocabulary";
import { ResetPasswordModel } from "../Utils/Models";
import { HttpStatusCode } from "../Utils/Constants";

export default function ResetPassword() {
  const { token, email } = useParams();
  const navigate = useNavigate();
  const [resetData, setResetData] = useState<ResetPasswordModel>(new ResetPasswordModel());
  const [errorText, setErrorText] = useState("");
  const [successText, setSuccessText] = useState("");
  const tokenId = token?.split("=")[1];
  /**
   *
   */
  const handleSubmit = async () => {
    if (!tokenId) return;
    if (resetData.password !== resetData.confirmPassword) {
      setErrorText(Vocabulary.passwordsDoNotMatch);
      setSuccessText("");
      return;
    }

    localStorage.setItem("access_token", tokenId);

    try {
      const url = endpoints.resetPassword;
      const data = { email: email?.split("=")[1], password: resetData.password };
      const response = await postData(url, { ...data });
      if (response && response?.data && response?.data?.code) {
        setSuccessText(Vocabulary.resetInProgress);
        setErrorText("");
        setTimeout(() => {
          navigate(localUrlEnum.login);
        }, 2500);
      } else {
        setErrorText(Vocabulary.loginValidationError);
        setSuccessText("");
      }
    } catch (err: any) {
      if (err.response && err.response.status === HttpStatusCode.Unauthorized) {
        setErrorText(Vocabulary.loginValidationError);
        setSuccessText("");
      }
      else if (err.message) {
        console.error(err);
        setErrorText(err.message);
        setSuccessText("");
      }
    }
  };


  /**
   *
   * @param event
   */
  const onChangeTextField = (event: any) => {
    const newUser: any = Object.assign({}, resetData);
    newUser[event.target.name] = event.target.value;
    setResetData(newUser);
  };

  return (
    <div className={styles.App}>
      <div className={styles.blurOverlay} />
      <Paper className={styles.loginContainer} elevation={5}>
        <Grid container spacing={1} className={styles.gridMainContainer}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className={styles.firstGrid}
          >
            <img
              src={"/sigur-la-volan.png"}
              alt="SigurLaVolan"
              width={"100%"}
            />
            <ValidatorForm className={styles.form} onSubmit={handleSubmit}>
              <TextValidator
                variant="standard"
                id="password"
                name="password"
                fullWidth
                label={Vocabulary.newPassword}
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
                value={resetData.password}
                onChange={(e) => onChangeTextField(e)}
                className={styles.textfield}
              />
              <TextValidator
                variant="standard"
                id="confirmPassword"
                name="confirmPassword"
                fullWidth
                label={Vocabulary.confirmPassword}
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
                value={resetData.confirmPassword}
                onChange={(e) => onChangeTextField(e)}
                className={styles.textfield}
              />
              <Button
                variant="contained"
                type="submit"
                className={styles.submit}
              >
                {Vocabulary.resetPassword}
              </Button>
              <Typography className={styles.errorText}>{errorText}</Typography>
              <Typography className={styles.successMessage}>{successText}</Typography>

              <Button
                variant="outlined"
                type="reset"
                color="secondary"
                className={styles.reset}
                onClick={() => navigate(localUrlEnum.login)}
              >
                {Vocabulary.back}
              </Button>
            </ValidatorForm>

          </Grid>
        </Grid>

      </Paper>
    </div>
  );
}
